import { useEffect } from 'react';
import scrollama from "scrollama";
import ReactMarkdown from 'react-markdown'

import './App.css';
// import mySvg from './portrait.svg';

import { profile, experience, skills, education, contact } from './content'

// Helper functions to generate markdown from structured data
const generateExperienceHeader = (exp) => `
  ### ${exp.company}
  #### ${exp.title} - ${exp.period}
`;

const generateExperienceContent = (exp, index) => {
  let content = `##### ${exp.description}\n\n`;
  
  if (exp.logo) {
    content += `[![${exp.logo.alt}](${exp.logo.src})](${exp.logo.link})\n\n`;
  }
  
  if (exp.achievements) {
    content += exp.achievements.map(achievement => `- ${achievement}`).join('\n') + '\n\n';
  }
  
  if (exp.brands) {
    exp.brands.forEach(brand => {
      content += `[![${brand.name}](${brand.logo})](${brand.link})\n\n`;
      if (brand.highlights) {
        content += brand.highlights.map(highlight => `###### ${highlight}`).join('\n') + '\n';
      }
      if (brand.achievements) {
        content += brand.achievements.map(achievement => `- ${achievement}`).join('\n') + '\n\n';
      }
    });
  }
  
  if (exp.corporate) {
    content += `#### ${exp.corporate.title}\n\n`;
    content += `###### ${exp.corporate.description}\n\n`;
    content += exp.corporate.achievements.map(achievement => `- ${achievement}`).join('\n') + '\n\n';
  }
  
  if (exp.highlight) {
    content += `${exp.highlight.description}\n\n`;
    content += exp.highlight.achievements.map(achievement => `- ${achievement}`).join('\n') + '\n\n';
  }
  
  if (exp.responsibilities) {
    content += `${exp.responsibilities}\n\n`;
  }
  
  if (exp.sampleProjects) {
    content += `Sample Projects\n`;
    content += exp.sampleProjects.map(project => `- [${project.name}](${project.link})`).join('\n') + '\n\n';
  }
  
  if (exp.background) {
    content += `${exp.background}\n\n`;
  }
  
  return content;
};

const generateClientLogos = (exp) => {
  if (!exp.clientLogos) return '';
  return exp.clientLogos.map(logo => 
    logo.link 
      ? `[![${logo.alt}](${logo.src})](${logo.link})`
      : `![${logo.alt}](${logo.src})`
  ).join('\n');
};

const generateSkillsContent = () => `
### Technical skills
${skills.technical.map(skill => `- ${skill}`).join('\n')}

### Skills 
${skills.professional.map(skill => `- ${skill}`).join('\n')}

### Education 
${education.university}
--
${education.preparatory}
`;

const generateFooterContent = () => `
# ${contact.name}
## ${contact.email}
## ${contact.phone}
`;

// instantiate the scrollama
const scroller = scrollama();

function App() {

  useEffect(() => {
    // setup scroller instance, pass callback functions
    scroller.setup({
      step: ".step",
      offset: 0.3,
      debug: false
    })
      .onStepEnter((response) => {
        // { element, index, direction }
        response.element.classList.add("step-active")

        let toc = document.getElementById('toc').getElementsByTagName('li');

        for (var y = 0, l = toc.length; y < l; y++) {
          toc[y].classList.remove('current-tab')
        }

        // Map step elements to correct navigation items
        const stepId = response.element.id;
        let navIndex = 0;
        
        if (stepId === 'profile') {
          navIndex = 0;
        } else if (stepId === 'experience') {
          navIndex = 1;
        } else if (stepId === 'skills') {
          navIndex = 2;
        } else if (stepId === 'contact') {
          navIndex = 3;
        } else {
          // Default to last navigation item for any other sections
          navIndex = 3;
        }
        if (toc[navIndex]) {
          toc[navIndex].classList.add('current-tab')
        }

      })
      .onStepExit((response) => {
        // { element, index, direction }
        response.element.classList.remove("step-active")
      });

    // make sure sticky isn't getting nulled by an overflow
    let parent = document.querySelector('.sticky').parentElement;

    while (parent) {
      const hasOverflow = getComputedStyle(parent).overflow;
      if (hasOverflow !== 'visible') {
        // Check for overflow styles that might affect sticky positioning
      }
      parent = parent.parentElement;
    }

  });

  return (
    <div className="App bg-ettio-700 pb-8">

      <div className="step" data-step="z" id="profile">
        <div className='fixed top-0 max-w-4xl w-full mx-auto bg-opacity-95 z-50 pt-1 pl-5 bg-ettio-900 text-sm h-7'>
          <div>Benjamin Wade Lundquist <span className="hidden sm:inline">| benjamin@ettio.com | 551-388-6763</span></div>
        </div>

        <div className="block-intro">
          <div className="w-full">
            <div className="max-w-xl">
              <div className="headline">
                <h3>Benjamin Lundquist</h3>
              </div>
              <ReactMarkdown children={ profile.intro } />
            </div>
          </div>
        </div>

      </div>

      <div id="toc" className="step-toc" data-step="a">
        <ul>
          <li><a href="#profile">Profile</a></li>
          <li><a href="#experience">Experience</a></li>
          <li><a href="#skills">Skills</a></li>
          <li><a href="#contact">Contact</a></li>
        </ul>
      </div>

      <div className="step step1" data-step="a" id="experience">

        <div className="scrolly scrolly-0">
          <figure>
            <ReactMarkdown children={ generateExperienceHeader(experience[0]) } />
          </figure>
          <article>
            <ReactMarkdown children={ generateExperienceContent(experience[0]) } />
          </article>
        </div>


        <div className="scrolly scrolly-1">
          <figure>
            <ReactMarkdown children={ generateExperienceHeader(experience[1]) } />
          </figure>
          <article>
            <ReactMarkdown children={ generateExperienceContent(experience[1]) } />
          </article>
        </div>

        <div className="scrolly scrolly-2">
          <figure className='sticky'>
            <ReactMarkdown children={ generateExperienceHeader(experience[2]) } />
          </figure>
          <article>
            <ReactMarkdown children={ generateExperienceContent(experience[2]) } />
            <div className="logos">
              <h6 className="text-center">Select Projects</h6>
              <ReactMarkdown children={ generateClientLogos(experience[2]) } />
            </div>
          </article>
        </div>

        <div className="scrolly scrolly-3">
          <figure className='sticky'>
            <ReactMarkdown children={ generateExperienceHeader(experience[3]) } />
          </figure>
          <article>
            <ReactMarkdown children={ generateExperienceContent(experience[3]) } />
            <div className="logos">
              <h6 className="text-center">Select Clients</h6>
              <ReactMarkdown children={ generateClientLogos(experience[3]) } />
            </div>
          </article>
        </div>

        <div className="scrolly scrolly-4">
          <figure className='sticky'>
            <ReactMarkdown children={ generateExperienceHeader(experience[4]) } />
          </figure>
          <article>
            <ReactMarkdown children={ generateExperienceContent(experience[4]) } />
          </article>
        </div>

        <div className="scrolly scrolly-5">
          <figure className='sticky'>
            <ReactMarkdown children={ generateExperienceHeader(experience[5]) } />
          </figure>
          <article>
            <ReactMarkdown children={ generateExperienceContent(experience[5]) } />
            <div className="logos">
              <h6 className="text-center">Select Projects</h6>
              <ReactMarkdown children={ generateClientLogos(experience[5]) } />
            </div>
          </article>
        </div>


      </div>

      <div className="step step2 relative step-skills" data-step="b" id="skills">
        <div className="p-5 z-10">
          <ReactMarkdown children={ generateSkillsContent() } />
        </div>
      </div>

      <div className="step step3 relative" data-step="c" id="contact">
        <div className="p-5 z-10">
          <ReactMarkdown children={ generateFooterContent() } />
        </div>
      </div>

    </div>
  )
}

export default App;
